"use client"

import styled from "@emotion/styled"
import { NewText } from "ui"

const StyledLayout = styled.div`
  padding: 0 30px;
  ${(props) => props.theme.breakpoints.up("sm")} {
    padding: 100px;
    flex: 1;
    padding-bottom: 0;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding: 170px;
    padding-bottom: 0;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 2;
`

const MainHeading = styled(NewText)`
  /* max-width: 706px; */
`

const SecondaryHeading = styled(NewText)<{ textAlign?: string }>`
  margin-bottom: 10px;
`

const Description = styled(NewText)`
  margin: 20px 0;
  /* max-width: 566px; */
`

const Tagline = styled(NewText)`
  margin-bottom: 20px;
  /* max-width: 415px; */
`

export default function HeroContent() {
  return (
    <StyledLayout>
      <MainHeading
        component="h1"
        mobileFontSize={72}
        smallDesktopFontSize={82}
        desktopFontSize={123}
        desktopLineHeight="76.6%"
        desktopFontWeight={700}
        color="white"
      >
        הבית שלכם נפגע במלחמה?
      </MainHeading>
      <Description
        component="p"
        mobileFontSize={25}
        smallDesktopFontSize={25}
        desktopFontSize={36}
        desktopLineHeight={"99.6%"}
        desktopFontWeight={200}
        color="white"
      >
        מוקד המומחים של BG BOND ושיפוצים פלוס כאן כדי ללוות ולחבר אתכם לאנשי המקצוע הטובים ביותר
        לעבודות השיפוץ והשיקום. כדי שגם אתם תוכלו לחזור לשגרה במהירות ובלי כאבי ראש מיותרים.
      </Description>
      <SecondaryHeading
        component={"p"}
        desktopLineHeight={"97.6%"}
        smallDesktopFontSize={34.5}
        desktopFontSize={52}
        mobileFontSize={27}
        desktopFontWeight={700}
        color="white"
      >
        מוקד המומחים של BG BOND בשיתוף שיפוצים פלוס.
      </SecondaryHeading>
      <Tagline
        component="p"
        mobileFontSize={19}
        smallDesktopFontSize={24}
        desktopFontSize={36}
        desktopLineHeight={"98%"}
        desktopFontWeight={700}
        color="white"
      >
        בי.גי.בונד. פשוט עובד.
      </Tagline>
    </StyledLayout>
  )
}
